import React from "react";
import { animated } from "@react-spring/web";
// import { Item } from "./styles";
import Modal from "../../components/Modal/Modal";
import MenuItem from "../../components/MenutItem/MenuItem";

export function MenuModal(setOpen, open, rest, width, height, transitions) {
  return (
    <Modal toggle={() => setOpen(false)} open={open} style={{ ...rest, width, height }}>
      {transitions((style, item) => {
        return (
          <animated.div
            key={item.imageUrl}
            style={{ ...style, cursor: "pointer" }}
            className="menuItem"
            onClick={dragToContent(item)}
          >
            <MenuItem text={item.name} overlayColor={"yellow"} imageUrl={item.imageUrl} />
          </animated.div>
        );
      })}
    </Modal>
  );

  function dragToContent(item) {
    return () => {
      document.getElementById(item.id)?.scrollIntoView();
      setOpen(false);
    };
  }
}
